<script setup>
import { ChevronUpIcon } from '@heroicons/vue/24/outline'
import { ref } from 'vue';
import { formatPrice } from '../../../../_Formats/prices.js';

const showDetails = ref(false);

const props = defineProps({
    swoogoInvoice: {
        type: Object,
        required: true,
    },
});
</script>
<template>
    <div class="font-Poppins">
        <div>
            <img src="/checkouts/pactoglobal/img/logo.jpg" class="w-full object-contain max-w-[190px]">
        </div>
        <div class="mt-5">
            <p class="text-sm md:text-base font-semibold text-pactoglobal-blue-dark">Importe a pagar</p>
            <p class="text-3xl md:text-5xl font-bold text-pactoglobal-blue-text">{{formatPrice(props.swoogoInvoice.group_balance_due)}}<span class="ml-2 text-base md:text-lg">MXN</span></p>
        </div>
        <div v-show="showDetails" class="mt-10 space-y-3">
            <div class="flex flex-col gap-0">
                <p class="text-sm font-bold text-pactoglobal-blue-dark">Nombre del evento:</p>
                <p class="text-lg font-semibold text-pactoglobal-blue-text">{{ props.swoogoInvoice.event.name }}</p>
            </div>
            <div class="flex flex-col gap-0">
                <p class="text-sm font-bold text-pactoglobal-blue-dark">Detalles:</p>
                <p class="text-lg font-semibold text-pactoglobal-blue-text" v-html="props.swoogoInvoice.event.description"></p>
            </div>
        </div>
        <button @click="showDetails = !showDetails"
            class="flex items-center gap-2 text-sm bg-pactoglobal-blue text-pactoglobal-blue-secondary px-4 py-2 rounded-xl uppercase font-bold mt-8">
            <span>{{ showDetails ? 'Ocultar' : 'Ver detalles' }}</span>
            <ChevronUpIcon
                :class="['h-5 w-5 transition duration-300 ease-in-out', showDetails ? 'rotate-0' : 'rotate-180']" />
        </button>
        <div class="mt-5">
            <p class="text-sm md:text-base font-bold">Correo electrónico</p>
            <div class="w-full mt-2 py-3 px-4 text-left text-gray-700 font-semibold ring-1 ring-gray-300 rounded-xl">
                <p>{{props.swoogoInvoice.email}}</p>
            </div>
        </div>
    </div>
</template>